import clsx from 'clsx';
import { Dispatch, SetStateAction, useMemo } from 'react';
import { useGetUserPermissions } from '../../../hooks';
import { IntegrationService, UploadMediaType } from '../../../types';
import { conditionalArray } from '../../../utils';
import { ImportFromIntegrationCard } from '../ImportFromIntegrationCard';
import { ManualUploadCard } from '../ManualUploadCard';
import { Typography, TypographyType } from '../Typography';

interface SelectUploadMediaTypeProps {
  setMediaType: Dispatch<SetStateAction<UploadMediaType | undefined>>;
  disabled?: boolean;
  disabledTooltip?: string;
}

const SelectUploadMediaType = ({ setMediaType, disabled, disabledTooltip }: SelectUploadMediaTypeProps) => {
  const { canUserViewGong, canUserViewSalesloft } = useGetUserPermissions();

  const sharedIntegrationCardProps = {
    setMediaType,
    selectCallButtonDisabled: disabled,
    selectCallButtonDisabledTooltip: disabledTooltip,
  };

  const selectMediaCards = useMemo(
    () => [
      ...conditionalArray(canUserViewGong, {
        id: IntegrationService.GONG,
        content: (props: { className: string }) => (
          <ImportFromIntegrationCard
            service={IntegrationService.GONG}
            className={clsx('bg-gong-purple-light', props.className)}
            {...sharedIntegrationCardProps}
          />
        ),
      }),
      ...conditionalArray(canUserViewSalesloft, {
        id: IntegrationService.SALESLOFT,
        content: (props: { className: string }) => (
          <ImportFromIntegrationCard
            service={IntegrationService.SALESLOFT}
            className={clsx('bg-salesloft-teal-light', props.className)}
            {...sharedIntegrationCardProps}
          />
        ),
      }),
      {
        id: 'manual',
        content: (props: { className: string }) => (
          <ManualUploadCard
            setMediaType={setMediaType}
            disabled={disabled}
            disabledTooltip={disabledTooltip}
            className={props.className}
          />
        ),
      },
    ],
    [canUserViewGong, canUserViewSalesloft, setMediaType, disabled, disabledTooltip]
  );
  return (
    <div className="flex flex-grow flex-col gap-2">
      <Typography type={TypographyType.BASE}>Select media</Typography>
      <div className="flex flex-col">
        {selectMediaCards.map((card, index) => (
          <div key={card.id}>
            {card.content({
              className: clsx(index === selectMediaCards.length - 1 && 'rounded-b-lg', index === 0 && 'rounded-t-lg'),
            })}
          </div>
        ))}
      </div>
    </div>
  );
};

export default SelectUploadMediaType;
